import React from 'react';

/** Inline “SyberKey” — white “Syber” + gold “Key”, same pattern as syberkey-site. */
export default function SyberKeyInlineMark({ className = '' }: { className?: string }) {
  return (
    <span className={className}>
      <span className="brand-white">Syber</span>
      <span className="brand-yellow">Key</span>
    </span>
  );
}
